import classNames from "classnames"
import React from "react"
import { connect } from "react-redux"
import { blockUi, unBlockUi } from "../../../actions/actionCreator"
import { aemHostClient, eapiClient } from '../../../restClient'
import { Translations, isEmptyObject } from "../../../utils"
import { setCurrentActiveTab } from "../../CaseBody/actions/actionCreator"
import NavListAccordionWrapper from "../../common/CashFlowForecastingAccordion/cashFlowForecastingAccordion"
import NavListAccordion from "../../common/NavListAccordion/NavListAccordion"
import NavigationList from "../../common/NavigationList"
import { setSowAgent, setSowAllProducts, setSowSelectedProduct } from "../../createASow/actions/actionCreator"
import { resetSowBodyCustomerActiveTabIndex } from "../actions/actionCreator"
import AdditionalCommentWIthImage from "./CashConcentrationSummary/AdditionalCommentWithImage"
import CashConBilling from "./CashConcentrationSummary/CashConBilling"
import "./index.css"
class GLSProduct extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            sowAllProductData: [],
            miscBillingAccordionIndex: 0,
            billingDetails: [{}],
            allAccounts: [],
            billingData: {},
            navigationProductData: {},
            sowTabStatus: this.props.sowTabStatus || {},
            glsPageJson: {},
            showSowBillingAdditionalCommentsModal: false
        }
    }

    componentWillMount() {
        this.props.history && this.props.history.location && this.props.history.location.state && this.props.history.location.state.updateGLSTabStatus &&
            this.props.getTabStatus && this.props.getTabStatus();

        if (this.props.savedSow.statusValue === 'Acknowledged By Customer' || this.props.savedSow.statusValue === 'Sent to Implementation Manager') {
            this.setState({ isCustAck: true });
        }
        this.getAllProduct()
        this.getAllNonThirdPartyAccounts()
        this.getBillingData()
        this.getGlsPageJson()
    }

    componentWillReceiveProps(nextProps) {
        if (JSON.stringify(nextProps.sowTabStatus) !== JSON.stringify(this.props.sowTabStatus)) {
            this.setState({
                sowTabStatus: nextProps.sowTabStatus
            })
        }
    }

    getAllProduct = () => {
        const { entities = [] } = this.props
        this.props.blockUi && this.props.blockUi();
        this.props.getTabStatus && this.props.getTabStatus();
        let currentAgent = entities.filter(el => el.agent).length ? entities.filter(el => el.agent)[0] : {}
        eapiClient('/sows/' + this.props.sowId + '/allProducts')
            .then(({ data }) => {
                if (data.responseData) {
                    this.setState({
                        sowAllProductData: data.responseData,
                    })
                    this.props.setSowAllProducts(data.responseData);
                    this.getProductDetailsData(currentAgent);
                }
            })
    }

    getTranslation = (word) => {
        return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    }

    componentDidMount() {
        this.props.resetSowBodyCustomerActiveTabIndex()
    }

    getProductDetailsData = (currentAgent = {}) => {
        const { sowTabStatus = {} } = this.state;
        if (sowTabStatus && sowTabStatus.glsProductStatus) {

            const _navigationProductData = {
                gls: this.state.sowAllProductData.length ? this.state.sowAllProductData.map(product => {
                    const additionalData = {
                        glsAgent: {
                            name: currentAgent.registeredName || "",
                            value: currentAgent.id || ""
                        },
                        productStatus: sowTabStatus.glsProductStatus && sowTabStatus.glsProductStatus[product.glsProductType.value] &&
                            sowTabStatus.glsProductStatus[product.glsProductType.value].status,
                        disabled: false
                    }
                    return { ...product, ...additionalData }
                }) : []
            }
            this.setState({
                navigationProductData: _navigationProductData,
            })
            this.props.unBlockUi && this.props.unBlockUi()
        }
    }

    getAccountList = () => {
        return (Array.isArray(this.state.allAccounts) && this.state.allAccounts.map(el =>
            ({ ...el, country: el.location }))) || []
    }

    getBillingData = () => {
        if (this.props.sowId) {
            const apiUrl = `/sows/${this.props.savedSow.id}/billing`
            eapiClient(apiUrl).then(({ data }) => {
                if (data.responseData && data.responseData.length) {
                    this.setState({
                        billingData: data.responseData[0],
                        billingDetails: data.responseData[0].billingDetails && data.responseData[0].billingDetails.length ? data.responseData[0].billingDetails : [{}]
                    })
                    this.props.unBlockUi && this.props.unBlockUi()
                }
            })
        }
    }

    handleUpdateBilling = (callback) => {
        if (this.state.billingData.id) {
            const apiUrl = `/sows/${this.state.billingData.id}/billing`
            const payload = {
                sowId: this.props.savedSow.id,
                billingDetails: this.state.billingDetails
            }
            this.props.blockUi && this.props.blockUi()
            eapiClient(apiUrl, {
                method: 'PUT',
                data: JSON.stringify(payload)
            }).then(({ data }) => {
                if (data.responseData) {
                    this.setState({
                        billingData: data.responseData,
                        billingDetails: data.responseData.billingDetails && data.responseData.billingDetails.length ? data.responseData.billingDetails : [{}]
                    })
                    this.props.getTabStatus && this.props.getTabStatus()
                }
                this.props.unBlockUi && this.props.unBlockUi()
                callback && callback()
            })
        } else {
            this.saveBillingDetails()
            callback && callback()
        }
    }

    handleBillingFormChange = (formData = {}, billingAccountIndex) => {
        const newBillingDetails = [...this.state.billingDetails] || []
        if (newBillingDetails[billingAccountIndex]) {
            newBillingDetails[billingAccountIndex] = { ...formData }
            this.setState({ billingDetails: newBillingDetails })
        }
    }

    getBillingAccounts = () => {
        this.props.blockUi && this.props.blockUi()
        const apiUrl = `/sows/${this.props.activeEntity && this.props.activeEntity.id}/sow-account-info`
        eapiClient(apiUrl, {
            method: 'GET'
        }).then(response => {
            this.props.unBlockUi && this.props.unBlockUi()
            const { data } = response || {}
            if (Array.isArray(data.responseData) && data.responseData.length) {
                const thirdPartyAccounts = data.responseData.filter(acc => Boolean(acc.isThirdPartyAccount))
                const accounts = data.responseData.filter(acc => !Boolean(acc.isThirdPartyAccount))
                this.setState({
                    accounts,
                    thirdPartyAccounts
                })
            }
        })
    }

    getAllNonThirdPartyAccounts = () => {
        if (this.props.sowId) {
            const apiUrl = `/sows/${this.props.sowId}/allAccounts`
            eapiClient(apiUrl).then(({ data }) => {
                if (data.responseData) {
                    this.setState({ allAccounts: data.responseData.filter(acc => !acc.isThirdPartyAccount) })
                }
            })
        }
    }

    saveBillingDetails = () => {
        const apiUrl = "/sows/billing"
        const payload = {
            sowId: this.props.savedSow.id,
            billingDetails: this.state.billingDetails
        }
        this.props.blockUi && this.props.blockUi()
        eapiClient(apiUrl, {
            method: "POST",
            data: JSON.stringify(payload)
        }).then(({ data }) => {
            if (data.responseData) {
                this.setState({
                    billingData: data.responseData,
                    billingDetails: data.responseData.billingDetails && data.responseData.billingDetails.length ? data.responseData.billingDetails : [{}]
                })
                this.props.getTabStatus && this.props.getTabStatus()
            }
            this.props.unBlockUi && this.props.unBlockUi()
        })
    }

    handleAddDelAccount = (accounts = []) => {
        this.setState({
            billingData: { ...this.state.billingData, billingDetails: accounts },
            billingDetails: accounts
        })
    }

    getGlsPageJson = async () => {
        const { data } = await aemHostClient('/aemData/formData/json_sow-product-requests')
        if (data) {
            this.setState({
                glsPageJson: data
            })
        }
    }

    // getBillingComment = async () => {
    //     this.props.blockUi && this.props.blockUi();
    //     const { data } = await eapiClient('/sows/getSowBillingComment/' + this.props.sowId)
    //     this.props.unBlockUi && this.props.unBlockUi();
    //     if (data.responseData) {
    //         this.setState({ sowBillingCommentData: data.responseData })
    //     }
    // }

    // saveBillingComment = async (notes = []) => {
    //     const payload = {
    //         sowId: this.props.sowId,
    //         notes,
    //         id: this.state.sowBillingCommentData.id
    //     }
    //     this.props.blockUi && this.props.blockUi();
    //     const { data } = await eapiClient('/sows/saveSowBillingComment', { method: 'POST', data: JSON.stringify(payload) })
    //     if (data.responseData) {
    //         this.setState({
    //             sowBillingCommentData: data.responseData,
    //             showSowBillingAdditionalCommentsModal: false
    //         })
    //     }
    // }

    render() {
        const { entities = [], tabs = {} } = this.props
        let currentAgent = entities.filter(el => el.agent).length ? entities.filter(el => el.agent)[0] : {}

        return (

            <article className="sow-gls-products-container">
                <section className="add-gls-product">
                    <button class="gdocs-btn-default"
                        disabled={this.props.isReadOnly && this.props.isReadOnly()}
                        onClick={() => {
                            this.props.history.push("/edit-a-sow/product-mapping")
                        }}
                    ><span class="icon icon-add addicon "></span>Add Product</button>
                </section>
                <section className='entities-accordion-container'>
                    <section className='sow-customer-list-container'>
                        <article>
                            <section className="basic-details-section">
                                <section className='basic-details-accordion-data sow-gls-tab'>
                                    <h3 className="heading" style={{ fontSize: '14px' }}>
                                        {this.state.glsPageJson && this.state.glsPageJson.par && this.state.glsPageJson.par.navigation_list_glsProducts ? this.getTranslation(this.state.glsPageJson.par.navigation_list_glsProducts.title) : ''}
                                    </h3>
                                    <NavigationList
                                        entities={{}}
                                        history={this.props.history}
                                        listtype="caseBodyProductRequests"
                                        pageReferer="gls"
                                        // accountCountryList={this.state.currentListAccountCountries}
                                        cases={this.props.cases}
                                        productDetailsdata={this.state.navigationProductData}
                                        lang={this.props.lang}
                                        productType="gls-sow"
                                        agentText={this.state.glsPageJson && this.state.glsPageJson.par && this.state.glsPageJson.par.navigation_list_glsProducts ? this.getTranslation(this.state.glsPageJson.par.navigation_list_glsProducts.agent) : ''}
                                        deleteModalContent={this.state.glsPageJson && this.state.glsPageJson.par ? this.state.glsPageJson.par.modal_deleteSowProductModal : {}}
                                        sowId={this.props.sowId}
                                        deleteProduct={() => {
                                            this.props.getSowDetails();
                                            this.getAllProduct()
                                        }}
                                        setSowAgent={() => {
                                            if (!isEmptyObject(currentAgent)) {
                                                this.props.setSowAgent(currentAgent)
                                            }
                                        }}
                                        setSowSelectedProduct={(glsProduct) => {
                                            if (glsProduct) {
                                                this.props.setSowSelectedProduct(glsProduct)
                                            }
                                        }}
                                        customer={this.props.customer}
                                        isCustAck={this.props.isCustAck}
                                        isReadOnly={this.props.isReadOnly}
                                    >
                                    </NavigationList>
                                </section>
                            </section>
                            <section className="sow-misc-billing">
                                <NavListAccordionWrapper open={this.state.miscBillingAccordionIndex == 0}
                                    key={"entity-" + 0}
                                >
                                    <NavListAccordion
                                        lang={this.props.lang.currentLang.lang}
                                        navAccHeading={`Billing`}
                                        status={this.state.sowTabStatus && this.state.sowTabStatus.glsProductStatus && this.state.sowTabStatus.glsProductStatus.billing &&
                                            this.state.sowTabStatus.glsProductStatus.billing.status || "incomplete"}
                                        _onClick={() => this.setState({ miscBillingAccordionIndex: 1 })}
                                    >
                                        <CashConBilling
                                            formJson={this.state.glsPageJson.par}
                                            sowAgent={this.props.sowAgent}
                                            lang={this.props.lang}
                                            accountList={this.getAccountList()}
                                            handleBillingFormChange={this.handleBillingFormChange}
                                            handleUpdateBilling={this.handleUpdateBilling}
                                            history={this.props.history}
                                            customer={this.props.customer.roleDetails.customer}
                                            isCustAck={this.state.isCustAck}
                                            billingDetails={this.state.billingDetails}
                                            handleAddDelAccount={this.handleAddDelAccount}
                                            isReadOnly={this.props.isReadOnly}
                                            setCurrentActiveTab={this.props.setCurrentActiveTab}
                                        />
                                    </NavListAccordion>
                                </NavListAccordionWrapper>
                            </section>
                            {this.props.customer && this.props.customer.roleDetails && !this.props.customer.roleDetails.customer ?
                                <div className='sow-billing-additional-comment'>
                                    <div
                                        className={classNames("view-cust-comments-link", { "disabled": 0 })}
                                        onClick={() => { this.setState({ showSowBillingAdditionalCommentsModal: true }) }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                this.setState({ showSowBillingAdditionalCommentsModal: true })
                                            }
                                        }}
                                        role="link"
                                        tabIndex={0}
                                    >
                                        {this.getTranslation(this.state.glsPageJson.par ? this.state.glsPageJson.par.sowBillingComments : 'Additional Comment')}
                                    </div>
                                    {this.state.glsPageJson.par && this.state.glsPageJson.par.modal_sowBillingComments && this.state.showSowBillingAdditionalCommentsModal ?
                                        <AdditionalCommentWIthImage
                                            showDialog={this.state.showSowBillingAdditionalCommentsModal}
                                            toggleDialog={() => {
                                                this.setState({ showSowBillingAdditionalCommentsModal: !this.state.showSowBillingAdditionalCommentsModal })
                                            }}
                                            bsClass={"billing-comment-modal"}
                                            modalTitle={this.getTranslation(this.state.glsPageJson.par.modal_sowBillingComments.title)}
                                            addCommentBtn={this.getTranslation(this.state.glsPageJson.par.modal_sowBillingComments.redBtn)}
                                            addCommentLabel={this.getTranslation(this.state.glsPageJson.par.modal_sowBillingComments.subTitle)}
                                            sowId={this.props.sowId}
                                            noteOne={this.getTranslation(this.state.glsPageJson.par.modal_sowBillingComments.noteOne)}
                                            noteTwo={this.getTranslation(this.state.glsPageJson.par.modal_sowBillingComments.noteTwo)}
                                            blockUi={this.props.blockUi}
                                            unBlockUi={this.props.unBlockUi}
                                        />
                                        : null
                                    }
                                </div> : null}
                        </article>
                    </section>

                </section >
            </article >

        )
    }
}


const mapStateToProps = state => {
    return {
        savedSow: state.sowEntities && state.sowEntities.savedSow,
        sowAgent: state.sowEntities.sowAgent || {},
        customer: state.auth.userDetails,
        caseMenu: state.caseMenuInfo
    }
}
const mapDispatchToProps = dispatch => {
    return {
        setSowAgent: data => {
            dispatch(setSowAgent(data));
        },
        setSowSelectedProduct: data => {
            dispatch(setSowSelectedProduct(data));
        },
        setSowAllProducts: data => {
            dispatch(setSowAllProducts(data));
        },
        resetSowBodyCustomerActiveTabIndex: () => {
            dispatch(resetSowBodyCustomerActiveTabIndex())
        },
        blockUi: () => {
            dispatch(blockUi())
        },
        unBlockUi: () => {
            dispatch(unBlockUi())
        },
        setCurrentActiveTab: (activeTabId) => {
            dispatch(setCurrentActiveTab(activeTabId));
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GLSProduct)



// WEBPACK FOOTER //
// ./src/components/SowBody/GLSProduct/index.js